import { Amplify } from 'aws-amplify-internal'

export function configureAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
        loginWith: {
          username: true,
          email: true,
          phone: true,
        },
      },
    },
  })
}
